import * as React from 'react';
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ThemeProvider } from '@mui/material/styles';
import { useAuth } from '../../components/AuthProvider';
import theme from '../login/themeLogin';
import { Link, useNavigate } from 'react-router-dom';
import { Paper } from '@mui/material';
import api from '../../services/api';
import backgroundImg from '../../components/imgs/background.jpg'
import { grey, red } from '@mui/material/colors';

export default function RecoverPassword() {
  const navigate = useNavigate()
  const auth = useAuth()

  React.useEffect(() => {
    if (auth.user != null) {
      navigate('/')
    }
  }, [auth.user, navigate])

  React.useEffect(() => {
    document.title = "IPV7 Tools - Recuperar senha"
  }, [])

  const [errorInput, setErrorInput] = React.useState({ email: false })
  const [sending, setSending] = React.useState(false)
  const [sent, setSent] = React.useState(false)
  const [errorMsg, setErrormsg] = React.useState({
    severity: "error",
    msg: "",
    show: false
  })

  const handleSubmit = (event) => {
    event.preventDefault();
    if (sending || sent) return;

    setErrorInput({ email: false })
    setErrormsg(errorMsg => ({ ...errorMsg, show: false }))

    const data = new FormData(event.currentTarget);
    const email = (data.get('email') || '').trim()

    if (!email || email.length < 5 || !email.includes('@')) {
      setErrorInput({ email: true })
      setErrormsg({ show: true, msg: "Informe um email válido.", severity: 'warning' })
      return;
    }

    setSending(true)
    api.post("recovery/", { email }).then(res => {
      setSent(true)
      setErrormsg({
        show: true,
        msg: res.data?.message
          || "Se o email estiver cadastrado, você receberá as instruções para recuperar sua senha.",
        severity: 'success',
      })
      setTimeout(() => navigate('/login'), 5000)
    }).catch(err => {
      // Antes qualquer falha aqui virava mensagem de sucesso — o usuário
      // ficava esperando um email que nunca tinha sido enviado.
      const status = err.response?.status
      if (status === 429) {
        setErrormsg({
          show: true,
          severity: 'warning',
          msg: "Muitas tentativas seguidas. Aguarde alguns minutos e tente novamente.",
        })
      } else if (!status) {
        setErrormsg({
          show: true,
          severity: 'error',
          msg: "Não foi possível falar com o servidor. Verifique sua conexão e tente novamente.",
        })
      } else {
        setErrormsg({
          show: true,
          severity: 'error',
          msg: "Não foi possível enviar o email de recuperação. Se o problema continuar, avise o administrador do sistema.",
        })
      }
    }).finally(() => setSending(false))
  };

  return (
    <ThemeProvider theme={theme}>

      <div component="main" maxWidth={false}
        style={{
          p: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'end',
          justifyContent: 'center',
          height: '100vh',
          backgroundImage: `url(${backgroundImg})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <CssBaseline />
        <Box minWidth={300} sx={{
          display: 'flex',
          mr: { xs: 0, sm: 0, md: 20 }
        }}
        >
          <Paper elevation={2} component="form" onSubmit={handleSubmit} noValidate sx={{
            mt: 1,
            width: { sm: 500, md: 500 },
            p: 5,
            m: 5,
            backgroundColor: 'rgba(242, 242, 242, 1)',
          }}>
            <Typography variant="h6" sx={{ color: grey[900], mb: 1 }}>
              Recuperar senha
            </Typography>
            <Typography variant="body2" sx={{ color: grey[700], mb: 1 }}>
              Informe o email da sua conta. Enviaremos um link para você
              cadastrar uma nova senha — o link vale por 1 hora.
            </Typography>
            <TextField
              error={errorInput.email}
              margin="normal"
              required
              fullWidth
              name="email"
              label="Insira seu email"
              type="email"
              id="email"
              autoComplete="email"
              autoFocus
              disabled={sending || sent}
              helperText={errorInput.email ? "Verifique este campo." : ''}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={sending || sent}
              sx={{
                mt: 3, mb: 2,
                backgroundColor: grey[900],
              }}
            >
              {sending ? "Enviando..." : "Recuperar senha"}
            </Button>
            <Link to={"/login"} style={{ textDecoration: 'none', color: red[900] }}>
              <Typography variant="body2" color="text.secondary" align="center">
                Voltar para o login
              </Typography>
            </Link>
            <Alert severity={errorMsg.severity}
              sx={{ display: errorMsg.show ? '' : 'none', mt: 2 }}
            >{errorMsg.msg}</Alert>
          </Paper>
        </Box>

      </div>
    </ThemeProvider>
  );
}
